/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import InitHeadermenu from "./modules/navigation";
import InitAccordion from './modules/accordion';
import InitNumberAnimation from './modules/number-animation';
import InitImageGallery from './modules/image-gallery';
import InitMediaViewer from './modules/media-viewer';
import InitInfiniteScrolling from './modules/infinite-scrolling';
import InitCountdown from './modules/countdown';
import InitForms from './modules/form';
import InitEventFilter from "./modules/event-filter";
import InitSitemap from "./modules/sitemap";
import easydropdown from 'easydropdown';
import InitAboBooking from "./modules/abo-booking";
import CookieByte from "./modules/cookie-byte";

const siteInitialization = () => {
	InitHeadermenu();
	InitAccordion();
	InitNumberAnimation();
	InitImageGallery();
	InitMediaViewer();
	InitInfiniteScrolling();
	InitCountdown();
	InitForms();
	InitEventFilter();
	InitSitemap();
	InitAboBooking();
	CookieByte.init();

	easydropdown.all();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);